import { __, __x, __nx, __N } from 'JIX/gettext.js';

export default {
    header: (companyname) =>
        __x('Ledige job hos {companyname}', { companyname }),
    noJobsIntro: (companyname) =>
        __x('Her får du et overblik over de ledige stillinger hos {companyname}. Der er desværre ingen jobannoncer for øjeblikket.', { companyname }),
    jobagentHeader: (companyname) =>
        __x('Opret Jobagent for {companyname}', { companyname }),
    jobagentShort: (companyname) =>
        __x('Få notifikationer når {companyname} har job der matcher din profil.', { companyname }),
    jobagentButton: () =>
        __('Opret Jobagent'),
    unsolicitedShortText: () =>
        __('Søg uopfordret'),
    unsolicitedLongerText: () =>
        __('Send en uopfordret ansøgning, hvor du ikke søger på baggrund af et opslået job.'),
    loadingJobs: () =>
        __('Henter job…'),
};
